module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGNsYXNzPSJpb25pY29uIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiI+PHBhdGggZD0iTTQ1MCAxMjhhNDYgNDYgMCAwMC00NC4xMSA1OWwtNzEuMzcgNzEuMzZhNDUuODggNDUuODggMCAwMC0yOSAwbC01Mi45MS01Mi45MWE0NiA0NiAwIDEwLTg5LjEyIDBMNzUgMjkzLjg4QTQ2LjA4IDQ2LjA4IDAgMTAxMDYuMTEgMzI1bDg3LjM3LTg3LjM2YTQ1Ljg1IDQ1Ljg1IDAgMDAyOSAwbDUyLjkyIDUyLjkyYTQ2IDQ2IDAgMTA4OS4xMiAwTDQzNyAyMTguMTJBNDYgNDYgMCAxMDQ1MCAxMjh6Ii8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/analytics-sharp.svg
// module id = iXkB
// module chunks = 1